import {CustomFieldResourceTypeEnum} from '@frontapp/workflows/custom_fields';
import React, {FC, memo} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {boxedInputColorReaders} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {DropdownBoxCoordinator} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {computeCustomFieldIconName} from '../../../../../../helpers/customFieldViewHelpers';
import {CustomFieldModel} from '../../../../../../models/api/customFieldModel';
import {CustomFieldDropdown} from '../../../../../common/dropdowns/customFields/customFieldDropdown';

/*
 * Props.
 */

export interface ConversationCustomFieldNameFieldProps {
  selectedCustomField: CustomFieldModel | undefined;
  conversationCustomFields: ReadonlyArray<CustomFieldModel>;
  onChange: (arg: CustomFieldModel | undefined) => void;
}

/*
 * Styles.
 */

const StyledPlaceholderSpan = styled.span`
  color: ${boxedInputColorReaders.textPlaceholder};
`;

/*
 * Components.
 */

export const ConversationCustomFieldNameField: FC<ConversationCustomFieldNameFieldProps> = memo((props) => {
  const {selectedCustomField, conversationCustomFields, onChange} = props;

  const theme = useUserTheme();

  const leftIcon = selectedCustomField
    ? computeCustomFieldIconName(selectedCustomField.type, VisualSizesEnum.SMALL)
    : 'customFieldsSmall';
  const leftIconColor = selectedCustomField ? theme.greys.shade90 : undefined;
  const value = selectedCustomField ? (
    selectedCustomField.name
  ) : (
    <StyledPlaceholderSpan>
      <Trans id="search-query-builder-custom-field-placeholder">Select custom field</Trans>
    </StyledPlaceholderSpan>
  );

  return (
    <DropdownBoxCoordinator
      leftIcon={leftIcon}
      leftIconColor={leftIconColor}
      value={value}
      renderDropdown={(popoverProps) => (
        <CustomFieldDropdown
          popoverProps={popoverProps}
          customFields={conversationCustomFields}
          allSelectedCustomFieldIds={[]}
          selectedCustomFieldId={selectedCustomField?.id}
          customFieldResourceType={CustomFieldResourceTypeEnum.CONVERSATION}
          onSelect={onChange}
          headerRightIcon={
            selectedCustomField ? (
              <Button
                variant={ButtonVariantsEnum.LINK}
                size={VisualSizesEnum.SMALL}
                onClick={() => {
                  onChange(undefined);
                  popoverProps.onRequestClose();
                }}
              >
                <Trans id="clear-refinement-button-link">Clear</Trans>
              </Button>
            ) : null
          }
        />
      )}
      shouldDisablePadding
    />
  );
});
